import * as React from 'react';
import AppLayout from './AppLayout/NavBar';

const Layout = () => {
  return <AppLayout />;
};

export default Layout;
